import { z } from "zod";
import { defineStepConfig } from "../../registry/helpers";

export const runReplenishmentEngineStep = defineStepConfig({
  type: "run_replenishment_engine",
  name: "Run Replenishment Engine",
  description:
    "Detects inventory deficits (policy-based) and uncovered sales order demand, generates buy/transfer options, optimizes supplier carts for MOV/freight thresholds, and persists ranked suggestions.",
  category: "Transformation",
  libraryModule: "Procurement",
  inputSchema: z.object({
    divisionId: z
      .string()
      .uuid()
      .optional()
      .describe("Scope engine run to a specific division"),
    warehouseIds: z
      .array(z.string().uuid())
      .optional()
      .describe("Scope engine run to specific warehouses"),
    placementDate: z.iso
      .date()
      .optional()
      .describe(
        "Business date (YYYY-MM-DD) the run prices against, e.g. to replay a past batch. Defaults to today's date in the organization's timezone (Settings > Organization; UTC when unset).",
      ),
  }),
  outputSchema: z.object({
    batchId: z.string().uuid(),
    placementDate: z.iso.date(),
    needsDetected: z.number(),
    deficitNeedsDetected: z.number(),
    soNeedsDetected: z.number(),
    suggestionsCreated: z.number(),
    suggestionsUpdated: z.number(),
    suggestionsSkipped: z.number(),
    optionsCreated: z.number(),
    transferOptionsCount: z.number(),
    buyOptionsCount: z.number(),
    hybridOptionsCount: z.number(),
    belowMinimumCount: z.number(),
    noSourcePathCount: z.number(),
    durationMs: z.number(),
  }),
  configSchema: z.object({
    dryRun: z
      .boolean()
      .prefault(false)
      .describe(
        "If true, detect needs and generate options but do not persist",
      ),
  }),
  emits: [] as const,
  execution: {
    startToCloseTimeout: "30 minutes",
    retry: { maximumAttempts: 2 },
  },
});
